import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import PayrollSystemWrapper from "@components/layouts/payrollSystemWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function PayrollSystemHome(): ReactElement {
    return (
        <PayrollSystemWrapper>
            <PrivacyPolicy
                category="Payroll System"
                domain="PayrollSystem.com"
            />
        </PayrollSystemWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
